export default {
  CL_GreenFurSweater: {
    src: new URL(
      "./Lookbook-CL-GreenPuffySweater.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-CL-GreenPuffySweater.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-CL-GreenPuffySweater.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-CL-GreenPuffySweater.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-CL-GreenPuffySweater.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-CL-GreenPuffySweater.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-CL-GreenPuffySweater.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  CL_Poncho: {
    src: new URL(
      "./Lookbook-CL-Poncho.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-CL-Poncho.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-CL-Poncho.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-CL-Poncho.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-CL-Poncho.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-CL-Poncho.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-CL-Poncho.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  CL_ShirtChino: {
    src: new URL(
      "./Lookbook-CL-ShirtChino.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-CL-ShirtChino.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-CL-ShirtChino.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-CL-ShirtChino.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-CL-ShirtChino.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-CL-ShirtChino.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-CL-ShirtChino.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  CL_TeePintuckPant: {
    src: new URL(
      "./Lookbook-CL-Tee.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-CL-Tee.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-CL-Tee.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-CL-Tee.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-CL-Tee.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-CL-Tee.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-CL-Tee.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  FF_CropSweater: {
    src: new URL(
      "./Lookbook-FF-CropSweater_0220.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-FF-CropSweater_0220.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FF-CropSweater_0220.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FF-CropSweater_0220.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-FF-CropSweater_0220.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FF-CropSweater_0220.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FF-CropSweater_0220.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  FF_RibSweater: {
    src: new URL(
      "./Lookbook-FF-RibSweater_0220.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-FF-RibSweater_0220.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FF-RibSweater_0220.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FF-RibSweater_0220.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-FF-RibSweater_0220.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FF-RibSweater_0220.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FF-RibSweater_0220.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  FF_Shirtdress: {
    src: new URL(
      "./Lookbook-FF-Shirtdress_0220.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-FF-Shirtdress_0220.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FF-Shirtdress_0220.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FF-Shirtdress_0220.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-FF-Shirtdress_0220.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FF-Shirtdress_0220.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FF-Shirtdress_0220.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  FT_Shirtdress: {
    src: new URL(
      "./Lookbook-FT-Shirtdress.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-FT-Shirtdress.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FT-Shirtdress.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FT-Shirtdress.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-FT-Shirtdress.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FT-Shirtdress.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FT-Shirtdress.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  FT_Bomber: {
    src: new URL(
      "./Lookbook-FT-Bomber.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-FT-Bomber.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FT-Bomber.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FT-Bomber.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-FT-Bomber.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FT-Bomber.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FT-Bomber.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  FT_Coveralls: {
    src: new URL(
      "./Lookbook-FT-Coveralls.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-FT-Coveralls.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FT-Coveralls.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FT-Coveralls.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-FT-Coveralls.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FT-Coveralls.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FT-Coveralls.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
  FT_KnitVest: {
    src: new URL(
      "./Lookbook-FT-KnitVest.png?as=png&width=700",
      import.meta.url
    ) as any as string,
    srcSet: {
      webp: `${
        new URL(
          "./Lookbook-FT-KnitVest.png?as=webp&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FT-KnitVest.png?as=webp&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FT-KnitVest.png?as=webp&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
      png: `${
        new URL(
          "./Lookbook-FT-KnitVest.png?as=png&width=900?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 900w,${
        new URL(
          "./Lookbook-FT-KnitVest.png?as=png&width=700?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 700w,${
        new URL(
          "./Lookbook-FT-KnitVest.png?as=png&width=500?withoutEnlargement=true",
          import.meta.url
        ) as any as string
      } 500w,`,
    },
  },
};
